import React from 'react'
import PropTypes from 'prop-types'
import { t } from '@insight/toolkit-utils'
import Button from '../Button/Button'

export const PDPError = ({ closeModal }) => (
  <div className="c-pdp__error">
    <div className="u-margin-bot-large">
      {t('Information for this product is unavailable.')}
    </div>
    <div className="o-grid o-grid--justify-right">
      <Button color="primary" onClick={closeModal}>
        Close
      </Button>
    </div>
  </div>
)

PDPError.propTypes = {
  /** close modal callback function */
  closeModal: PropTypes.func.isRequired,
}

export default PDPError
